import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../../components/DashboardLayout";
import { formatTime, getDayFromDate } from "../../../utility/Common";
import Loader from "../../../components/Loader";
import { getClassesAPI } from "../../../services/portal/admin/classService";
import { showErrorToastMsg } from "../../../utility/ToastMessage";
import { CalendarIcon } from "../../../icons/CalendarIcon";
import { TimeIcon } from "../../../icons/TimeIcon";
import { RoutePaths } from "../../../utility/RoutePaths";

const AdminDashboardPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [classes, setClasses] = useState([]);

  useEffect(() => {
    loadClasses();
  }, []);

  const loadClasses = async () => {
    setLoading(true);
    try {
      const res = await getClassesAPI();
      if (res && res.IsSuccessful && res.Data) {
        setClasses(res.Data);
      }
    } catch (error) {
      console.error("Error loading classes:", error);
      showErrorToastMsg("Failed to load classes");
    } finally {
      setLoading(false);
    }
  };

  const handleCardClick = (classId) => {
    navigate(`${RoutePaths.ADMIN_STUDENT_MANAGE_PAGE}?classId=${classId}`);
  };

  const renderClassCard = (classItem) => {
    const classId = classItem.ClassId;

    return (
      <div
        key={classId}
        onClick={(e) => handleCardClick(classId)}
        className={`bg-white rounded-lg shadow-md p-6 transition duration-300 border-l-4 cursor-pointer ${
          classItem.Status === 1
            ? "border-yellow-600 opacity-75"
            : "border-primary-600 hover:shadow-xl"
        }`}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-bold text-gray-900">{classItem.Name}</h3>
        </div>

        <div className="flex justify-between text-gray-600 mt-4">
          <div className="flex items-center">
            <CalendarIcon />
            <div>
              <p className="font-semibold text-sm">
                {getDayFromDate(classItem.StartDate)}
              </p>
            </div>
          </div>
          <div className="flex items-center">
            <TimeIcon />
            <div>
              <p className="font-semibold text-sm">
                {formatTime(classItem.StartTime) +
                  " - " +
                  formatTime(classItem.EndTime)}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <DashboardLayout title="Dashboard" subtitle="Welcome back!">
      {loading ? (
        <div className="flex justify-center items-center py-12">
          <Loader />
        </div>
      ) : (
        <>
          {/* Available Classes Section */}
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Online Classes
            </h2>
            {classes.length === 0 ? (
              <div className="text-center py-12">
                <p className="text-gray-600 text-lg">No classes available</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6">
                {classes.map((classItem) => renderClassCard(classItem))}
              </div>
            )}
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default AdminDashboardPage;
